import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  DoCheck,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ControlsModalComponent } from './controls-modal/controls-modal.component';
import cloneDeep from 'lodash/cloneDeep';
import { DataModelService } from '@services/data-model.service';
import { CourseService } from '@scaffold/services/course.service';
import { ViewsService } from '@services/views.service';
import { FileModalComponent } from '@scaffold/dialogs/file-modal/file-modal.component';
import { SearchModalComponent } from './search-modal/search-modal.component';
import { FontawesomeListService } from '@scaffold/services/fontawesome-list.service';
import { UntypedFormControl } from '@angular/forms';
import {
  ScaffoldDialogService,
  ScaffoldDialogRef,
} from '@app/framework/dialog/scaffold-dialog.service';
import { PropertiesService } from '../../services/properties.service';
import { NotificationsService } from '@services/notifications.service';

@Component({
    selector: 'app-controls',
    templateUrl: './controls.component.html',
    styleUrls: ['./controls.component.scss'],
    standalone: false
})
export class ControlsComponent implements OnInit, DoCheck, OnChanges {
  private _selectedItem;
  @Input()
  set selectedItem(val) {
    this._selectedItem = val;
    // console.log("Set selection", val);
    this.setup();
  }
  get selectedItem() {
    return this._selectedItem;
  }
  toggle: boolean = false;
  @Input() rootItem;
  @Input() item: any;
  @Input() parentView: any;
  @Input() fileSet: boolean;
  @Output() closeDialog = new EventEmitter<string>();
  @Output() setProperty = new EventEmitter<string>();
  model: string[];
  modelControl = new UntypedFormControl();
  dialogRef: ScaffoldDialogRef;
  iconCatagories;
  filteredIcons = [];
  dataViews = [];
  dataModes = [];
  dataModesOptions = [];
  dataKeys = [];
  dataItems = [];
  lastIf = true;
  oldData;
  hideClearImageBtn: boolean = true;
  other_modes;
  groupedOptions = [];
  other_types;
  other_id;
  value;
  tour = {};
  debounce;
  _color;
  set color(c) {
    if (c !== this.value) {
      this.value = c;
      this.sendUpdate();
    }
    this._color = c;
  }
  get color() {
    return this._color;
  }
  dataViewsOptions = [];
  colorOptions = [
    { value: '', label: 'Normal' },
    { value: 'block-color-red', label: 'Red' },
    { value: 'block-color-blue', label: 'Blue' },
    { value: 'block-color-green', label: 'Green' },
    { value: 'block-color-light', label: 'Light' },
    { value: 'block-color-med', label: 'Medium' },
    { value: 'block-color-dark', label: 'Dark' },
  ];
  constructor(
    public notification: NotificationsService,
    public dialog: ScaffoldDialogService,
    private dataModelService: DataModelService,
    private view: ViewsService,
    private icons: FontawesomeListService,
    public courseService: CourseService,
    private properties: PropertiesService
  ) {}

  _closeDialog(e) {
    this.closeDialog.emit(e);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.fileSet && changes.fileSet.currentValue) {
      this.hideClearImageBtn = changes.fileSet.currentValue ? false : true;
    }
    if (this.item?.type === 'other_mode' && this.item?.object_type) {
      console.log('changes', changes);
    }
  }

  openSettings(selectedItem, item): void {
    var settings: any = {
      context: {
        data: {
          selectedItem: selectedItem,
          item: item,
          parentView: this.parentView,
        },
      },
    };
    this.properties.disableProperties(true);
    this.dialogRef = this.dialog.open(ControlsModalComponent, settings);

    this.dialogRef.onClose.subscribe(result => {
      this.properties.disableProperties(false);
      this.closeDialog.emit('options');
      console.log(result);
    });
  }
  openSearch(selectedItem, param): void {
    console.log(selectedItem);
    let settings: any = {
      context: {
        width: '80%',
        position: { top: '20px' },
        data: {
          selectedItem: selectedItem,
          parentView: this.parentView,
          type: this.item.type,
          search_type: this.item.toload_type || selectedItem.toload_type,
          search_mode: selectedItem.toload_mode,
          context:
            selectedItem.parent_context === 'all'
              ? null
              : this.courseService.id
                ? { id: this.courseService.id, type: 'course' }
                : null,
        },
      },
    };
    this.properties.disableProperties(true);
    let dialogRef = this.dialog.open(SearchModalComponent, settings);

    dialogRef.onClose.subscribe(result => {
      this.properties.disableProperties(false);
      if (result && result.length > 0) {
        selectedItem[param] = result;
        this.closeDialog.emit('options');
      }
    });
  }
  selectFile(selectedItem, item, filter): void {
    let settings: any = {
      context: {
        width: '80%',
        data: {
          filter: filter,
        },
      },
    };
    this.properties.disableProperties(true);
    console.log(item);
    let dialogRef = this.dialog.open(FileModalComponent, settings);

    dialogRef.onClose.subscribe(result => {
      this.properties.disableProperties(false);
      if (typeof result === 'object') {
        console.log('Selected:', result);
        selectedItem[item] = result.id;
        this.hideClearImageBtn = false;
        if (!selectedItem['text'] || selectedItem['text'].length == 0)
          selectedItem['text'] = result.data.title;
        selectedItem['file_data'] = result.data;
        this.closeDialog.emit('file');
        console.log(selectedItem);
      }
    });
  }

  unSelectFile() {
    delete this.selectedItem.file;
    delete this.selectedItem.file_data;
    this.hideClearImageBtn = true;
    this.closeDialog.emit('file');
  }

  arrayLength(target, key, count, defaults) {
    target = target[key];
    count = target.length + count;
    console.log(count);
    if (target.length > count) {
      while (target.length > count) {
        target.splice(target.length - 1, 1);
      }
    } else {
      while (target.length < count) {
        target.push(cloneDeep(defaults));
      }
    }
  }
  filterKeys(arr, filter) {
    if (filter && filter.length > 0) {
      return arr.filter(item => {
        if (item.friendlyname && item.friendlyname.length > 0)
          return item.friendlyname
            .toLowerCase()
            .startsWith(filter.toLowerCase());
        else return item.name.toLowerCase().startsWith(filter.toLowerCase());
      });
    } else {
      return arr;
    }
  }
  getColumnWidths(arr, cur) {
    let total = 0;
    let widths = [];
    for (var i = 0; i < arr.length; i++) {
      total += parseInt(arr[i]);
    }
    if (cur) {
      cur = parseInt(cur);
      total = total - cur;
    }
    for (var w = 1; w + total <= 12; w++) {
      widths.push(w);
    }
    return widths;
  }

  getDataKeys() {}

  getSelectLabel(value, template = '{[label]}') {
    if (value) return template.replace('{[label]}', value);
  }

  getDataValues(data, label, template) {
    if (data.match(/\./)) {
      var split = data.split(/\./);
      try {
        var found = [];
        this[split[0]].forEach(selected => {
          if (selected.title === this.selectedItem[split[1]]) {
            found = selected.items;
          }
        });
      } catch (e) {
        console.log(e);
        return [];
      }
    } else {
      var found = this[data];
    }
    var items = [];
    if (found)
      found.forEach(item => {
        if (label) {
          items.push({
            key: item[label],
            label: this.getSelectLabel(item[label], template),
          });
        } else {
          items.push({ key: item, label: this.getSelectLabel(item, template) });
        }
      });
    return items;
  }

  checkIf() {
    if (this?.item?.if) {
      var rtn;
      this.item.if.forEach(cond => {
        if (
          (cond?.value && this?.selectedItem?.[cond?.param] === cond?.value) ||
          (cond?.defined && this?.selectedItem?.[cond?.param]) ||
          (cond?.not_defined && !this?.selectedItem?.[cond.param]) ||
          (cond?.not_value &&
            this?.selectedItem?.[cond?.param] !== cond?.not_value)
        ) {
          rtn = rtn != false && true;
        } else {
          rtn = false;
        }
      });
      if (rtn && !this.lastIf) {
        if (this.item.type === 'select') {
        }
      }
      this.lastIf = rtn;
      return rtn;
    }
    this.lastIf = true;
    return true;
  }

  ngDoCheck() {
    if (this?.item?.data) {
      try {
        var split = this.item.data.split(/\./);
        if (this.selectedItem[split[1]] !== this.oldData) {
          this.iconCatagories = this.icons.catagories;
          this.dataItems = this.getDataValues(
            this.item.data,
            this.item.dataLabel,
            this.item.template
          );
          this.oldData = this.selectedItem[split[1]];
        }
      } catch (e) {}
    }
    //watch for changes to data type input to load new modes as needed
    if (
      this?.item?.object_type &&
      this?.selectedItem?.[this.item.object_type]
    ) {
      let type = this.selectedItem[this.item.object_type];
      //console.log(this.other_types,type)
      if (!this.other_types) {
        this.getOtherModes();
      } else if (!this.other_types.push) {
        if (this.other_types != type) this.getOtherModes();
      } else {
        if (JSON.stringify(type) != JSON.stringify(this.other_types))
          this.getOtherModes();
      }
    }
  }

  ngOnInit() {
    this.setup();
  }

  setup() {
    //console.log(this.parentView);
    if (this.item && this.parentView) {
      if (this.item.param && this.selectedItem)
        this.value = this.selectedItem[this.item.param];
      if (this.item.type === 'color') this.color = this.value;
      if (this.item.type === 'select') {
        this.iconCatagories = this.icons.catagories;
        if (this.item.data) {
          this.dataItems = this.getDataValues(
            this.item.data,
            this.item.dataLabel,
            this.item.template
          );
        }
      }
      //  this.modelService.getModel('pages').subscribe(m => this.model = m);
      if (this.item.type === 'data_view' || this.item.type === 'data_search') {
        this.dataModelService.getTypes().subscribe(datas => {
          if (datas) {
            this.dataViews = datas;
            this.dataViewsOptions = [
              { value: '', label: 'None' },
              ...datas.map(d => ({ value: d.name, label: d.name })),
            ];
          }
        });
      }
      if (this.item.type === 'data_mode') {
        this.view.getModes(this.parentView.type).subscribe(modes => {
          this.dataModes = modes;
          this.dataModesOptions = [
            { label: 'None', value: '' },
            ...modes.map(m => ({ value: m.mode, label: m.mode })),
          ];
        });
      }
      if (this.item.type === 'other_mode' && this.item.object_type) {
        this.getOtherModes();
      }
      if (this.item.type === 'file_image') {
        this.hideClearImageBtn = this.selectedItem.hasOwnProperty(
          this.item.value
        );
      }
      if (this.item.type === 'settings_object') {
        if (!this.selectedItem.hasOwnProperty(this.item.param)) {
          this.selectedItem[this.item.param] = {};
        }
      }
      if (this.item.type === 'model') {
        if (this.item.data_type) {
          if (this.rootItem) {
            var type = this.rootItem[this.item.data_type];
          } else {
            var type = this.selectedItem[this.item.data_type];
          }
          if (type?.push) {
            type = type[0]?.name;
          }
          console.log('Key Type', type);
          this.dataModelService
            .getKeys(type)
            .subscribe(keys => this.addSearchItems(keys));
        } else {
          this.dataKeys = this.parentView.keys;
        }
      }
    }
  }

  private _filterIcons(event: any) {
    let value = event.query ? event.query : event;
    const filterValue = new RegExp(value.toLowerCase(), 'i');
    this.filteredIcons = this.icons.all.filter(option =>
      option.toLowerCase().match(filterValue)
    );
  }

  addSearchItems(keys) {
    if (keys && keys.length > 0) {
      keys.forEach(key => {
        this.dataKeys.push(key);
      });
    }
    console.log(this.dataKeys);
  }

  getViewID() {
    let id,
      type = this.selectedItem[this.item.param];
    this.dataModes.forEach(d => {
      if (d.mode == type) {
        id = d.id;
      }
    });
    this.other_id = id;
  }

  getOtherModes() {
    console.log(this.selectedItem);
    let type = this.selectedItem[this.item.object_type];
    this.other_types = cloneDeep(type);
    if (type) {
      this.other_modes = [];
      let types;
      if (type.push) types = type;
      else types = [type];

      types.forEach(t => {
        if (t) {
          let ty = t.name ? t.name : t;
          if (ty.length > 0) {
            this.view.getModes(ty).subscribe(modes => {
              console.log(modes);

              this.other_modes.push({
                type: t.name ? t.name : t,
                modes: modes,
              });
              this.groupedOptions = this.other_modes.map(group => ({
                label: group.type,
                items: group.modes.map(mode => ({
                  label: mode.mode,
                  value: mode.mode,
                })),
              }));
              this.dataModes = modes;
              this.dataModesOptions = [
                { label: 'None', value: '' },
                ...modes.map(m => ({ value: m.mode, label: m.mode })),
              ];
              this.getViewID();
            });
          }
        }
      });
    }
  }

  extractYoutubeId() {
    this.debounce = setTimeout(() => {
      console.log(this.value);
      let youTubeRegExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      let match = this.value.match(youTubeRegExp);
      this.value = match && match[7].length == 11 ? match[7] : this.value;
      this.sendUpdate();
    }, 1000);
  }

  checkValue(e) {
    const input = e?.target?.value;
    if (this.item.validate && input && !this.item.validate.test(input.trim())) {
      this.notification.popNotification(
        this.item?.invalidMessage || 'Invalid Value provided',
        ''
      );
    }
  }

  sendUpdate() {
    if (this.debounce) {
      console.log('Clear Debounce');
      clearTimeout(this.debounce);
    }

    this.debounce = setTimeout(() => {
      console.log('after debounce');
      this.selectedItem[this.item.param] = this.value;
      this.setProperty.emit('updated property');
    }, 500);
  }

  triggerUpdate() {
    if (this.debounce) {
      console.log('Clear Debounce');
      clearTimeout(this.debounce);
    }

    this.debounce = setTimeout(() => {
      console.log('after debounce');
      this.setProperty.emit('updated property');
    }, 500);
  }
  /**
   * Opens a new tab to the given URL - fix for a not working directly
   * @param url - The URL to open in a new tab
   */
  openInNewTab(url: string) {
    window.open(url, '_blank');
  }
}
